import './assets/index-CJAYjuyf.css';
import { t } from "@nextcloud/l10n";
import NcAvatar from "@nextcloud/vue/dist/Components/NcAvatar.js";
import NcSelect from "@nextcloud/vue/dist/Components/NcSelect.js";
import debounce from "lodash-es/debounce.js";
import NcActions from "@nextcloud/vue/dist/Components/NcActions.js";
import NcActionButton from "@nextcloud/vue/dist/Components/NcActionButton.js";
import { reactive, set } from "vue";
import axios from "@nextcloud/axios";
import { generateOcsUrl } from "@nextcloud/router";
class CollectionService {
  constructor() {
    this.http = axios;
  }
  listCollection(collectionId) {
    return this.http.get(generateOcsUrl("collaboration/resources/collections/{collectionId}", { collectionId }));
  }
  renameCollection(collectionId, collectionName) {
    return this.http.put(generateOcsUrl("collaboration/resources/collections/{collectionId}", { collectionId }), {
      collectionName
    }).then((result) => {
      return result.data.ocs.data;
    });
  }
  getCollectionsByResource(resourceType, resourceId) {
    return this.http.get(generateOcsUrl("collaboration/resources/{resourceType}/{resourceId}", { resourceType, resourceId })).then((result) => {
      return result.data.ocs.data;
    });
  }
  createCollection(resourceType, resourceId, name) {
    return this.http.post(generateOcsUrl("collaboration/resources/{resourceType}/{resourceId}", { resourceType, resourceId }), {
      name
    }).then((response) => {
      return response.data.ocs.data;
    });
  }
  addResource(collectionId, resourceType, resourceId) {
    resourceId = "" + resourceId;
    return this.http.post(generateOcsUrl("collaboration/resources/collections/{collectionId}", { collectionId }), {
      resourceType,
      resourceId
    }).then((response) => {
      return response.data.ocs.data;
    });
  }
  removeResource(collectionId, resourceType, resourceId) {
    return this.http.delete(generateOcsUrl("collaboration/resources/collections/{collectionId}", { collectionId }), { params: { resourceType, resourceId } }).then((response) => {
      return response.data.ocs.data;
    });
  }
  search(query) {
    return this.http.get(generateOcsUrl("collaboration/resources/collections/search/{query}", { query })).then((response) => {
      return response.data.ocs.data;
    });
  }
}
const service = new CollectionService();
const state = reactive({
  collections: []
});
const mutations = {
  addCollections(collections) {
    set(state, "collections", collections);
  },
  addCollection(collection) {
    state.collections.push(collection);
  },
  removeCollection(collectionId) {
    set(state, "collections", state.collections.filter((item) => item.id !== collectionId));
  },
  updateCollection(collection) {
    const index = state.collections.findIndex((_item) => _item.id === collection.id);
    if (index !== -1) {
      set(state.collections, index, collection);
    } else {
      state.collections.push(collection);
    }
  }
};
const actions = {
  fetchCollectionsByResource({ resourceType, resourceId }) {
    return service.getCollectionsByResource(resourceType, resourceId).then((collections) => {
      mutations.addCollections(collections);
      return collections;
    });
  },
  createCollection({ baseResourceType, baseResourceId, resourceType, resourceId, name }) {
    return service.createCollection(baseResourceType, baseResourceId, name).then((collection) => {
      mutations.addCollection(collection);
      actions.addResourceToCollection({
        collectionId: collection.id,
        resourceType,
        resourceId
      });
    });
  },
  renameCollection({ collectionId, name }) {
    return service.renameCollection(collectionId, name).then((collection) => {
      mutations.updateCollection(collection);
      return collection;
    });
  },
  addResourceToCollection({ collectionId, resourceType, resourceId }) {
    return service.addResource(collectionId, resourceType, resourceId).then((collection) => {
      mutations.updateCollection(collection);
      return collection;
    });
  },
  removeResource({ collectionId, resourceType, resourceId }) {
    return service.removeResource(collectionId, resourceType, resourceId).then((collection) => {
      if (collection.resources.length > 0) {
        mutations.updateCollection(collection);
      } else {
        mutations.removeCollection(collection);
      }
    });
  },
  search(query) {
    return service.search(query);
  }
};
function normalizeComponent(scriptExports, render3, staticRenderFns, functionalTemplate, injectStyles, scopeId, moduleIdentifier, shadowMode) {
  var options = typeof scriptExports === "function" ? scriptExports.options : scriptExports;
  if (render3) {
    options.render = render3;
    options.staticRenderFns = staticRenderFns;
    options._compiled = true;
  }
  if (functionalTemplate) {
    options.functional = true;
  }
  if (scopeId) {
    options._scopeId = "data-v-" + scopeId;
  }
  var hook;
  if (moduleIdentifier) {
    hook = function(context) {
      context = context || // cached call
      this.$vnode && this.$vnode.ssrContext || // stateful
      this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext;
      if (!context && typeof __VUE_SSR_CONTEXT__ !== "undefined") {
        context = __VUE_SSR_CONTEXT__;
      }
      if (injectStyles) {
        injectStyles.call(this, context);
      }
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier);
      }
    };
    options._ssrRegister = hook;
  } else if (injectStyles) {
    hook = shadowMode ? function() {
      injectStyles.call(
        this,
        (options.functional ? this.parent : this).$root.$options.shadowRoot
      );
    } : injectStyles;
  }
  if (hook) {
    if (options.functional) {
      options._injectStyles = hook;
      var originalRender = options.render;
      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context);
        return originalRender(h, context);
      };
    } else {
      var existing = options.beforeCreate;
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }
  return {
    exports: scriptExports,
    options
  };
}
const _sfc_main$1 = {
  name: "CollectionListItem",
  components: {
    NcAvatar,
    NcActions,
    NcActionButton
  },
  props: {
    collection: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      detailsOpen: false,
      newName: null,
      error: {}
    };
  },
  computed: {
    getIcon() {
      return (resource) => [resource.iconClass];
    },
    typeClass() {
      return (resource) => "resource-type-" + resource.type;
    },
    limitedResources() {
      return (collection) => collection.resources ? collection.resources.slice(0, 2) : [];
    },
    iconUrl() {
      return (resource) => {
        if (resource.mimetype) {
          return OC.MimeType.getIconUrl(resource.mimetype);
        }
        if (resource.iconUrl) {
          return resource.iconUrl;
        }
        return "";
      };
    }
  },
  methods: {
    t,
    toggleDetails() {
      this.detailsOpen = !this.detailsOpen;
    },
    showDetails() {
      this.detailsOpen = true;
    },
    hideDetails() {
      this.detailsOpen = false;
    },
    removeResource(collection, resource) {
      actions.removeResource({
        collectionId: collection.id,
        resourceType: resource.type,
        resourceId: resource.id
      });
    },
    openRename() {
      this.newName = this.collection.name;
    },
    renameCollection() {
      if (this.newName === "") {
        this.newName = null;
        return;
      }
      actions.renameCollection({
        collectionId: this.collection.id,
        name: this.newName
      }).then((collection) => {
        this.newName = null;
      }).catch((e) => {
        this.$set(this.error, "rename", t("core", "Failed to rename the project"));
        console.error(e);
        setTimeout(() => {
          set(this.error, "rename", null);
        }, 3e3);
      });
    }
  }
};
var _sfc_render$1 = function render() {
  var _vm = this, _c = _vm._self._c;
  return _c("li", { staticClass: "collection-list-item" }, [_c("NcAvatar", { staticClass: "collection-avatar", attrs: { "display-name": _vm.collection.name, "allow-placeholder": "" } }), _vm.newName === null ? _c("span", { staticClass: "collection-item-name", attrs: { "title": "" }, on: { "click": _vm.showDetails } }, [_vm._v(_vm._s(_vm.collection.name))]) : _c("form", { class: { "shouldshake": _vm.error.rename }, on: { "submit": function($event) {
    $event.preventDefault();
    return _vm.renameCollection.apply(null, arguments);
  } } }, [_c("input", { directives: [{ name: "model", rawName: "v-model", value: _vm.newName, expression: "newName" }], attrs: { "type": "text", "autocomplete": "off", "autocapitalize": "off" }, domProps: { "value": _vm.newName }, on: { "input": function($event) {
    if ($event.target.composing) return;
    _vm.newName = $event.target.value;
  } } }), _c("input", { staticClass: "icon-confirm", attrs: { "type": "submit", "value": "" } })]), !_vm.detailsOpen && _vm.newName === null ? _c("div", { staticClass: "linked-icons" }, _vm._l(_vm.limitedResources(_vm.collection), function(resource) {
    return _c("a", { key: resource.type + "|" + resource.id, class: _vm.typeClass(resource), attrs: { "title": resource.name, "href": resource.link } }, [_c("img", { attrs: { "src": _vm.iconUrl(resource) } })]);
  }), 0) : _vm._e(), _vm.newName === null ? _c("span", { staticClass: "sharingOptionsGroup" }, [_c("NcActions", [_c("NcActionButton", { attrs: { "icon": "icon-info" }, on: { "click": function($event) {
    $event.preventDefault();
    return _vm.toggleDetails.apply(null, arguments);
  } } }, [_vm._v(" " + _vm._s(_vm.detailsOpen ? _vm.t("core", "Hide details") : _vm.t("core", "Show details")) + " ")]), _c("NcActionButton", { attrs: { "icon": "icon-rename" }, on: { "click": function($event) {
    $event.preventDefault();
    return _vm.openRename.apply(null, arguments);
  } } }, [_vm._v(" " + _vm._s(_vm.t("core", "Rename project")) + " ")])], 1)], 1) : _vm._e(), _c("transition", { attrs: { "name": "fade" } }, [_vm.error.rename ? _c("div", { staticClass: "error" }, [_vm._v(" " + _vm._s(_vm.error.rename) + " ")]) : _vm._e()]), _c("transition", { attrs: { "name": "fade" } }, [_vm.detailsOpen ? _c("ul", { staticClass: "resource-list-details" }, _vm._l(_vm.collection.resources, function(resource) {
    return _c("li", { key: resource.type + "|" + resource.id, class: _vm.typeClass(resource) }, [_c("a", { attrs: { "href": resource.link } }, [_c("img", { attrs: { "src": _vm.iconUrl(resource) } }), _c("span", { staticClass: "resource-name" }, [_vm._v(_vm._s(resource.name || ""))])]), _c("span", { staticClass: "icon-close", on: { "click": function($event) {
      return _vm.removeResource(_vm.collection, resource);
    } } })]);
  }), 0) : _vm._e()])], 1);
};
var _sfc_staticRenderFns$1 = [];
var __component__$1 = /* @__PURE__ */ normalizeComponent(
  _sfc_main$1,
  _sfc_render$1,
  _sfc_staticRenderFns$1,
  false,
  null,
  "42733c12",
  null,
  null
);
const CollectionListItem = __component__$1.exports;
const METHOD_CREATE_COLLECTION = 0;
const METHOD_ADD_TO_COLLECTION = 1;
const _debouncedSearch = debounce(
  function(query, loading) {
    if (query !== "") {
      loading(true);
      actions.search(query).then((collections) => {
        this.searchCollections = collections;
      }).catch((e) => {
        console.error("Failed to search for collections", e);
      }).finally(() => {
        loading(false);
      });
    }
  },
  500,
  {}
);
const _sfc_main = {
  name: "CollectionList",
  components: {
    CollectionListItem,
    NcAvatar,
    NcSelect
  },
  props: {
    /**
     * Resource type identifier
     */
    type: {
      type: String,
      default: null
    },
    /**
     * Unique id of the resource
     */
    id: {
      type: String,
      default: null
    },
    /**
     * Name of the resource
     */
    name: {
      type: String,
      default: ""
    },
    isActive: {
      type: Boolean,
      default: true
    }
  },
  setup() {
    return {
      state
    };
  },
  data() {
    return {
      selectIsOpen: false,
      generatingCodes: false,
      codes: void 0,
      value: null,
      model: {},
      searchCollections: [],
      error: null,
      isSelectOpen: false
    };
  },
  computed: {
    collections() {
      return this.state.collections.filter((collection) => {
        return typeof collection.resources.find((resource) => resource && resource.id === "" + this.id && resource.type === this.type) !== "undefined";
      });
    },
    placeholder() {
      return this.isSelectOpen ? t("core", "Type to search for existing projects") : t("core", "Add to a project");
    },
    options() {
      const options = [];
      window.OCP.Collaboration.getTypes().sort().forEach((type) => {
        options.push({
          method: METHOD_CREATE_COLLECTION,
          type,
          title: window.OCP.Collaboration.getLabel(type),
          class: window.OCP.Collaboration.getIcon(type),
          action: () => window.OCP.Collaboration.trigger(type)
        });
      });
      for (const index in this.searchCollections) {
        if (this.collections.findIndex((collection) => collection.id === this.searchCollections[index].id) === -1) {
          options.push({
            method: METHOD_ADD_TO_COLLECTION,
            title: this.searchCollections[index].name,
            collectionId: this.searchCollections[index].id
          });
        }
      }
      return options;
    }
  },
  watch: {
    type() {
      if (this.isActive) {
        actions.fetchCollectionsByResource({
          resourceType: this.type,
          resourceId: this.id
        });
      }
    },
    id() {
      if (this.isActive) {
        actions.fetchCollectionsByResource({
          resourceType: this.type,
          resourceId: this.id
        });
      }
    },
    isActive(isActive) {
      if (isActive) {
        actions.fetchCollectionsByResource({
          resourceType: this.type,
          resourceId: this.id
        });
      }
    }
  },
  mounted() {
    actions.fetchCollectionsByResource({
      resourceType: this.type,
      resourceId: this.id
    });
  },
  methods: {
    t,
    select(selectedOption, id) {
      if (selectedOption.method === METHOD_CREATE_COLLECTION) {
        selectedOption.action().then((id2) => {
          actions.createCollection({
            baseResourceType: this.type,
            baseResourceId: this.id,
            resourceType: selectedOption.type,
            resourceId: id2,
            name: this.name
          }).catch((e) => {
            this.setError(t("core", "Failed to create a project"), e);
          });
        }).catch((e) => {
          console.error("No resource selected", e);
        });
      }
      if (selectedOption.method === METHOD_ADD_TO_COLLECTION) {
        actions.addResourceToCollection({
          collectionId: selectedOption.collectionId,
          resourceType: this.type,
          resourceId: this.id
        }).catch((e) => {
          this.setError(t("core", "Failed to add the item to the project"), e);
        });
      }
    },
    search(query, loading) {
      _debouncedSearch.bind(this)(query, loading);
    },
    showSelect() {
      this.selectIsOpen = true;
      this.$refs.select.$el.focus();
    },
    hideSelect() {
      this.selectIsOpen = false;
    },
    isVueComponent(object) {
      return object._isVue;
    },
    setError(error, e) {
      console.error(error, e);
      this.error = error;
      setTimeout(() => {
        this.error = null;
      }, 5e3);
    }
  }
};
var _sfc_render = function render2() {
  var _vm = this, _c = _vm._self._c;
  return _vm.collections && _vm.type && _vm.id ? _c("ul", { staticClass: "collection-list", attrs: { "id": "collection-list" } }, [_c("li", { on: { "click": _vm.showSelect } }, [_vm._m(0), _c("div", { attrs: { "id": "collection-select-container" } }, [_c("NcSelect", { ref: "select", attrs: { "aria-label-combobox": _vm.t("core", "Add to a project"), "options": _vm.options, "placeholder": _vm.placeholder, "label": "title", "limit": 5 }, on: { "close": function($event) {
    _vm.isSelectOpen = false;
  }, "open": function($event) {
    _vm.isSelectOpen = true;
  }, "option:selected": _vm.select, "search": _vm.search }, scopedSlots: _vm._u([{ key: "selected-option", fn: function(option) {
    return [_c("span", { staticClass: "option__desc" }, [_c("span", { staticClass: "option__title" }, [_vm._v(_vm._s(option.title))])])];
  } }, { key: "option", fn: function(option) {
    return [_c("span", { staticClass: "option__wrapper" }, [option.class ? _c("span", { staticClass: "avatar", class: option.class }) : option.method !== 2 ? _c("NcAvatar", { attrs: { "allow-placeholder": "", "display-name": option.title } }) : _vm._e(), _c("span", { staticClass: "option__title" }, [_vm._v(_vm._s(option.title))])], 1)];
  } }], null, false, 2397208459), model: { value: _vm.value, callback: function($$v) {
    _vm.value = $$v;
  }, expression: "value" } }, [_c("p", { staticClass: "hint" }, [_vm._v(" " + _vm._s(_vm.t("core", "Connect items to a project to make them easier to find")) + " ")])])], 1)]), _c("transition", { attrs: { "name": "fade" } }, [_vm.error ? _c("li", { staticClass: "error" }, [_vm._v(" " + _vm._s(_vm.error) + " ")]) : _vm._e()]), _vm._l(_vm.collections, function(collection) {
    return _c("CollectionListItem", { key: collection.id, attrs: { "collection": collection } });
  })], 2) : _vm._e();
};
var _sfc_staticRenderFns = [function() {
  var _vm = this, _c = _vm._self._c;
  return _c("div", { staticClass: "avatar" }, [_c("span", { staticClass: "icon-projects" })]);
}];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "8ebb2593",
  null,
  null
);
const CollectionList = __component__.exports;
export {
  CollectionList,
  CollectionListItem
};
